"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEAM = exports.BILLING = void 0;
var BILLING = 'billing';
exports.BILLING = BILLING;
var TEAM = 'team';
exports.TEAM = TEAM;